
import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'

import imgBannerPrompt from 'assets/banner-prompt@3x.png'

import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'


import QuestionCell from '../Common/QuestionCell.vue'

import { mapActions, mapState } from 'vuex'

import tourHelper from '../../utils/route-helper.js'
import videoPlay from '../../utils/video-play.js'

export default {
name: 'TourDetail',
components: {
XHeader,
XButton,
Card,
Previewer,
QuestionCell,
},
data() {
return {
addressIcon,
timeIcon,
imgBannerPrompt,
statusEnum: {
1: '立即预订',
2: '预订结束',
3: '售罄',
},
imgList: [],
}
},
computed: {
...mapState({
tour: ({ routes }) => routes.tourDetail,
}),
orderAble() {
return this.tour && this.tour.status === 1
},
submitBtnText() {
return this.statusEnum[this.tour.status] || '预订结束'
},
fromShare() {
const url = window.location.search
if (url.indexOf('?') !== -1) {
const queryString = url.substr(1)
return queryString.split('=')[1] === 'share'
}
return false
},
},
methods: {
...mapActions(['fetchTourDetail', 'toggleTouteFavour', 'showToast']),
gotoOrderConfirm() {
this.$router.push({
name: 'tour-confirm',
params: this.$router.params,
})
},
generateImgList() {
const images = document.querySelectorAll('.tour-detail-card img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
getSliceIntroductions() {

return [
this.tour.introductions.filter(e => e.order < 3),
this.tour.introductions.filter(e => e.order >= 3),
]
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {

const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
initialWeixinShare() {
const { wx } = window
const { tour } = this
if (wx) {
wx.ready(() => {
const shareInfo = {
title: tour.name,
desc: '《观赛日》全球体育赛事门票预定',
link: window.location.href,

imgUrl: '//qncommon.saiday.com/yoyo/common/share_icon.png',
}

wx.onMenuShareAppMessage(shareInfo)
wx.onMenuShareTimeline(shareInfo)
})
}
},
},
created() {
const { params: { tourId } } = this.$route
document.title = '线路详情'
this.fetchTourDetail({
id: tourId,
userId: this.$jwt.userId,
}).then((data) => {
this.imgList = this.generateImgList()
this.tour.videosArray.forEach((video) => {
const cover = video.cover ? video.cover.url : ''
videoPlay(video.id, video.url, cover)
})
tourHelper.changeDocumentTitle(data.name)

this.initialWeixinShare()
}).catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
setTimeout(() => {
window.history.back()
}, 1000)
})
},
}



// WEBPACK FOOTER //
// ./client/components/WorldCup/TourDetail.vue